const items = [
  {
    title: "顶流塌房全记录：从巅峰到谷底的 72 小时",
    desc: "完整梳理某顶流男星从被曝光到品牌解约的全过程，附时间线图表与关键人物关系图。",
    img: "https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20falling%20on%20empty%20stage%2C%20dark%20theater%20atmosphere%2C%20broken%20spotlight%20effect%2C%20mysterious%20red%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20film%20noir%20style%2C%20metaphor%20for%20fallen%20celebrity&width=800&height=500&seq=carousel-01&orientation=landscape",
    tag: "深度专题",
  },
  {
    title: "直播带货黑幕：你买的「正品」从哪来",
    desc: "深入调查直播电商供应链造假链条，从代工厂到假冒授权书的完整灰色产业链揭秘。",
    img: "https://readdy.ai/api/search-image?query=Dark%20warehouse%20filled%20with%20shipping%20boxes%2C%20dramatic%20shadows%2C%20mysterious%20supply%20chain%20scene%2C%20amber%20accent%20lighting%2C%20investigative%20photography%20style%2C%20industrial%20setting%20with%20moody%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape",
    tag: "深度专题",
  },
  {
    title: "综艺选秀内幕：镜头背后的资本游戏",
    desc: "多位前选秀选手联合爆料，揭示综艺节目如何通过剪辑和剧本操控观众情绪与投票走向。",
    img: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20studio%20with%20cameras%20and%20equipment%2C%20dark%20dramatic%20lighting%2C%20professional%20broadcast%20environment%2C%20moody%20cinematic%20photography%2C%20film%20set%20atmosphere%20with%20deep%20shadows&width=800&height=500&seq=carousel-03&orientation=landscape",
    tag: "系列报道",
  },
  {
    title: "网红孵化器的秘密：流量造星的代价",
    desc: "探访头部 MCN 机构运作模式，揭开网红批量制造背后对个人生活的全面控制与不平等合约。",
    img: "https://readdy.ai/api/search-image?query=Corporate%20office%20with%20dark%20glass%20reflections%2C%20anonymous%20silhouettes%20behind%20frosted%20glass%2C%20dramatic%20contrast%20lighting%2C%20mysterious%20business%20environment%2C%20film%20noir%20inspired%20photography%2C%20cold%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape",
    tag: "深度专题",
  },
  {
    title: "娱乐圈偷税漏税全集：手法与代价",
    desc: "系统整理近年明星偷逃税案件，解析阴阳合同、工作室避税等常见手法的运作机制。",
    img: "https://readdy.ai/api/search-image?query=Legal%20documents%20and%20financial%20papers%20scattered%20on%20dark%20desk%2C%20dramatic%20side%20lighting%2C%20investigative%20journalism%20aesthetic%2C%20warm%20amber%20highlights%20on%20paper%2C%20moody%20atmosphere%2C%20film%20noir%20style&width=800&height=500&seq=carousel-05&orientation=landscape",
    tag: "系列报道",
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 text-center mb-4">
          焦点深扒
        </h2>
        <div className="w-16 h-1 bg-primary-500 mx-auto mb-10 rounded-full"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-colors group cursor-pointer ${
                i === 0 ? "lg:col-span-2" : ""
              } ${i === 4 ? "lg:col-span-3" : ""}`}
            >
              <div className={`relative ${i === 0 ? "aspect-[16/7]" : i === 4 ? "aspect-[21/7]" : "aspect-[16/10]"}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="inline-block px-2.5 py-1 rounded text-xs font-semibold bg-primary-500/90 text-background-50 mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-foreground-100 text-base md:text-lg group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-400 text-xs mt-1 line-clamp-2">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}